// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fcCU","col":"styles_col__2jV0A"};